import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BusinessIcon from "@mui/icons-material/Business";

// Consistent pill size regardless of content (shared with BatteryLifePill)
const PILL_MIN_WIDTH = 100;

/**
 * Premium pill for Manufacturer (platform) column. Theme-aware, neutral style.
 */
export default function ManufacturerPill({ label }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const displayLabel = label && String(label).trim() !== "" ? String(label).trim() : "—";

  const greenColor = theme.palette.success?.main || "#A0C46D";
  const pillStyles = {
    backgroundColor: isDark ? "hsl(215, 22%, 24%)" : "rgba(100, 116, 139, 0.1)",
    color: isDark ? "rgba(255,255,255,0.9)" : theme.palette.text.primary,
    border: isDark
      ? "1px solid rgba(148, 163, 184, 0.2)"
      : "1px solid rgba(100, 116, 139, 0.2)",
    boxShadow: isDark
      ? "0 1px 3px rgba(0,0,0,0.2), 0 0 0 1px rgba(148, 163, 184, 0.06)"
      : "0 1px 2px rgba(0,0,0,0.04)",
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        minHeight: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "flex-start",
          alignSelf: "center",
          gap: "6px",
          minWidth: PILL_MIN_WIDTH,
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingTop: "3px",
          paddingBottom: "3px",
          borderRadius: "9999px",
          fontSize: "0.75rem",
          fontWeight: 600,
          letterSpacing: "0.02em",
          lineHeight: 1.3,
          whiteSpace: "nowrap",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          transition: "background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease",
          ...pillStyles,
          "&:hover": {
            backgroundColor: isDark ? "hsl(215, 22%, 28%)" : "rgba(100, 116, 139, 0.14)",
            borderColor: isDark ? "rgba(148, 163, 184, 0.28)" : "rgba(100, 116, 139, 0.28)",
          },
          "&:focus-visible": {
            outline: "none",
            boxShadow: `0 0 0 2px ${greenColor}40`,
          },
          "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "0.875rem",
            opacity: 0.9,
            margin: 0,
            flexShrink: 0,
            color: "inherit",
          },
        }}
      >
        <BusinessIcon fontSize="inherit" />
        <Box
          component="span"
          sx={{
            width: "7em",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "left",
          }}
        >
          {displayLabel}
        </Box>
      </Box>
    </Box>
  );
}
